// extracted by mini-css-extract-plugin
export default {"wrapper":"gW8CK79JdhlOrgz7PJ5w","keyboardKey":"NnzETPO9g1qFy3b3qYRw","presentationIndex":"Xyu7b39AzwUkvq_1ZeIw"};